<template>
  <app-base-main parentTable>
    <template #filter-group>
      <app-filter-group
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <gj-warehouse-select
            v-model="filter.warehouseIds"
            placeholder="仓库"
            multiple
            :fba="false"
            width="150px"
        ></gj-warehouse-select>
        <gj-select
            v-model="filter.costType"
            :options="option.costType"
            placeholder="全部类型"
        ></gj-select>
        <gj-select
            v-model="filter.status"
            :options="option.status"
            placeholder="状态"
        ></gj-select>
        <gj-date-picker
          v-model="filter.date"
          type="daterange"
          tooltip="创建时间"
        ></gj-date-picker>
        <gj-select-input
          v-model="filter.code"
          :options="option.code"
          :width="['100px', '140px']"
        ></gj-select-input>

        <template #right>
          <view-setting
                  :ref="REF_VIEW_SETTING"
                  save-mode="remote"
                  :use-default="true"
                  :module-name="moduleName"
                  :config="model"
                  :fn-generate-params="generateViewParams"
                  @view-change="handleChangeView"
                  @view-complete="handCompleteView"
          >
          </view-setting>
        </template>
      </app-filter-group>
    </template>
    <template #operate-group>
      <gj-button
        v-if="$permission('costSupplement:edit')"
        type="primary"
        @click="add()">
        成本补录
      </gj-button>
      <gj-button
          v-if="$permission('costSupplement:audit')"
          :disabled="noSelect || selectedSomeIsNot('status', StatusEnum.WAIT_REVIEW)"
          @click="auditPass(selectedRows)">
        审核通过
      </gj-button>
      <gj-button
          v-if="$permission('costSupplement:audit')"
          :disabled="noSelect || selectedSomeIsNot('status', StatusEnum.WAIT_REVIEW)"
          @click="auditFail(selectedRows)">
        审核驳回
      </gj-button>
      <gj-button
          v-if="$permission('costSupplement:delete')"
          :disabled="noSelect || selectedSomeNotIn('status', [StatusEnum.WAIT_REVIEW, StatusEnum.REJECTED])"
          @click="deleteItem(selectedRows)">
        删除
      </gj-button>
    </template>
    <template #tool-group>
      <gj-tool-group
          help
      ></gj-tool-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :name="tableName"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          selection
          :scroll-x="{gt: -1}"
          :scroll-y="{gt: -1}"
          :bak-selected-rows="bakSelectedRows"
          :bak-rows="selectedRows"
          @clearBakSelectedRows="clearBakRows"
          :selectable="(row) => row.$gjParentData && !row.$gjExtendRow"
          :extend-row-config="{prop: 'extendRow'}"
          :structure-config="{type: 'ParentChild', children: 'itemPageVOList', parentSpan: [1, 9]}"
          :pagination="pagination"
          :show-overflow="false"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:picture="{row}">
          <template v-if="row.$gjParentData">
            <div style="display: inline-block; width: 150px;">
              {{row.code | defaultShow}}
              <gj-copy-icon :content="row.code"></gj-copy-icon>
            </div>
            <div v-gutter="20" style="display: inline-block;">
              <gj-tag
                  type="plain"
                  shape="rectangle"
                  :color="row.status | optionColor(CostSupplementEnum.statusOption)">
                {{ row.status | optionText(CostSupplementEnum.statusOption) }}
              </gj-tag>
              <span><span class="parent-table-label">类型：</span>{{row.costType | optionText(CostSupplementEnum.costTypeOption) | defaultShow}}</span>
              <span><span class="parent-table-label">仓库：</span>{{row.warehouseName | defaultShow}}</span>
              <span><span class="parent-table-label">创建人：</span>{{row.createUserName | defaultShow}}</span>
              <span><span class="parent-table-label">创建时间：</span>{{row.createTime | defaultShow}}</span>
              <span><span class="parent-table-label">审批人：</span>{{row.approveUserName | defaultShow}}</span>
              <span><span class="parent-table-label">备注：</span><gj-text max-width="200px">{{row.memo | defaultShow}}</gj-text></span>
            </div>
          </template>
          <template v-else>
            <gj-image :src="row.smallImageUrl"></gj-image>
          </template>
        </template>
        <template v-slot:sku="{row}">
          <div><gj-text>{{row.productName | defaultShow}}</gj-text></div>
          <div>{{row.sku | defaultShow}}</div>
        </template>
        <template v-slot:purchaseCost="{row}">
          {{row.oldPurchaseCost | amount | defaultShow(row.currencySymbol)}} -> {{row.newPurchaseCost | amount | defaultShow(row.currencySymbol)}}
        </template>
        <template v-slot:totalPurchaseCost="{row}">
          {{row.oldTotalPurchaseCost | amount | defaultShow(row.currencySymbol)}} -> {{row.newTotalPurchaseCost | amount | defaultShow(row.currencySymbol)}}
        </template>
        <template v-slot:totalArriveCost="{row}">
          {{row.oldTotalArriveCost | amount | defaultShow(row.currencySymbol)}} -> {{row.newTotalArriveCost | amount | defaultShow(row.currencySymbol)}}
        </template>
        <template v-slot:op="{ row }">
          <template v-if="row.$gjParentData">
            <gj-button-group
                type="dropdown-op"
                :config="opBtnConfig(row)"
            ></gj-button-group>
          </template>
        </template>
        <template v-slot:extend:row="{row}">
          <div class="default">
            <div v-if="!row.expand">
              <gj-link type="default" @click="openDetail(row,true)">
                更多（共{{row.num}}条）
                <i class="iconfont iconzhankai"></i>
              </gj-link>
            </div>
            <div v-else>
              <gj-link type="default" @click="openDetail(row, false)">
                收起
                <i class="iconfont iconshouqi"></i>
              </gj-link>
            </div>
          </div>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {isMeaningfulMixin, queryMixin, responseMixin, selectionMixin, valueCheckMixin, bakSelectRowsMixin} from "@/minxins";
  import {
    auditFailCostSupplement,
    auditPassCostSupplement,
    deleteCostSupplement,
    getCostSupplementPage
  } from "@/api/warehouse";
  import {CostSupplementEnum} from "@/views/modules/warehouse/cost-supplement/enum";
  import {defaultVal} from "@/utils/common";
  import {convertToDate, generateViewParams} from "@/utils/date.util";
  import AppOpCostSupplement from "@/views/modules/warehouse/cost-supplement/modal/op/op-cost-supplement";
  import {OpEnum} from "@/utils/options";
  import viewConfig from './viewConfig'

  const StatusEnum = CostSupplementEnum.status;

  export default {
    name: "app-cost-supplement",
    mixins: [queryMixin, selectionMixin, isMeaningfulMixin, responseMixin, valueCheckMixin, bakSelectRowsMixin],
    data() {
      return {
        tableName: 'costSupplement',
        tableData:  [],
        columns: [
          {id: 'picture', header: '图片', field: 'slot:picture', width: '50px'},
          {id: 'sku', header: '产品名称/SKU', field: 'slot:sku', minWidth: '250px'},
          {id: 'relevanceCode', header: '关联单号', field: 'relevanceCode', width: '150px'},
          {id: 'quantity', header: '数量', field: 'quantity', width: '80px', align: 'right'},
          {id: 'purchaseCost', header: '采购成本', field: 'slot:purchaseCost', width: '180px'},
          {id: 'totalPurchaseCost', header: '总采购成本', field: 'slot:totalPurchaseCost', width: '180px'},
          {id: 'totalArriveCost', header: '总费用', field: 'slot:totalArriveCost', width: '180px'},
          {id: 'totalChangePurchaseCost', header: '总采购成本调整金额', field: 'oldTotalChangePurchaseCost', prefix: 'currencySymbol', width: '140px', align: 'right'},
          {id: 'totalChangeArriveCost', header: '总到库成本调整金额', field: 'newTotalChangeArriveCost', prefix: 'currencySymbol', width: '140px', align: 'right'},
          {id: 'op', header: '操作', field: 'slot:op', width: '150px', fixed: 'right'},
        ],
        opBtnConfig: (row) => [
          {
            label: '详情',
            click: () => this.view({...row, itemPageVOList: row.productsCopy})
          },
          {
            label: '编辑',
            show: () => this.$permission('costSupplement:edit')
              && this.someIs(row.status, [StatusEnum.REJECTED]),
            click: () => this.edit({...row, itemPageVOList: row.productsCopy})
          },
          {
            label: '审核通过',
            show: () => this.$permission('costSupplement:audit')
              && row.status === StatusEnum.WAIT_REVIEW,
            click: () => this.auditPass([{...row, itemPageVOList: row.productsCopy}])
          },
          {
            label: '审核驳回',
            show: () => this.$permission('costSupplement:audit')
              && row.status === StatusEnum.WAIT_REVIEW,
            click: () => this.auditFail([{...row, itemPageVOList: row.productsCopy}])
          },
          {
            label: '删除',
            show: () => this.$permission('costSupplement:delete')
              && this.someIs(row.status, [StatusEnum.WAIT_REVIEW, StatusEnum.REJECTED]),
            click: () => this.deleteItem([{...row, itemPageVOList: row.productsCopy}])
          },
        ],
        filter: {},
        option: {
          costType: CostSupplementEnum.costTypeOption,
          status: CostSupplementEnum.statusOption,
          code: [
            {id: 'code', text: '补录单号'},
            {id: 'relevanceCode', text: '关联单号'},
            {id: 'sku', text: 'SKU'},
            {id: 'productName', text: '产品名称'},
          ]
        },
        StatusEnum: StatusEnum,
        CostSupplementEnum: CostSupplementEnum,
        moduleName: 'COST_SUPPLEMENT',
        model: viewConfig
      };
    },
    methods: {
      generateViewParams,
      /**
       * 设置全局查询参数
       */
      mergeRemoteParams (params) {
        const date = params.date ? params.date : [params.startDateTime, params.endDateTime]
        this.filter = Object.assign({}, this.filter, {
          ...params,
          date
        })
      },
      $gjQueryInitParams() {
        return {
          filter: {
            warehouseIds: [],
            costType: null,
            status: null,
            date: [],
            code: {
              key: 'code',
              value: null
            }
          },
        };
      },
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            warehouseIdList: this.filter.warehouseIds,
            costType: defaultVal(this.filter.costType),
            status: defaultVal(this.filter.status),
            startCreateTime: this.filter.date[0] ? convertToDate(this.filter.date[0]) : null,
            endCreateTime: this.filter.date[1] ? convertToDate(this.filter.date[1]) : null,
            [this.filter.code.key]: defaultVal(this.filter.code.value)
          },
          ...this.queryPagination,
          ...this.querySort
        };
        // 查询
        this.loading = true;
        getCostSupplementPage(params)
          .then(data => {
            this.tableData = data.records.map((v, i) => {
              const itemPageVOList = this._.cloneDeep(v.itemPageVOList)
              return Object.assign(v, {
                productsCopy: itemPageVOList,
                itemPageVOList: itemPageVOList ? itemPageVOList.slice(0, 3) : [],
                expand: false,
                dataIndex: i
              })
            });
            this.pagination = this.getPagination(data);
          })
          .complete(() => this.loading = false);
      },
      // 成本补录
      add() {
        this.$gjCreate(AppOpCostSupplement, {
          props: {
            opType: OpEnum.type.ADD,
          },
          on: {
            audited: () => {
              this.$gjResetPage();
            }
          }
        });
      },
      // 成本补录详情
      view(row) {
        this.$gjCreate(AppOpCostSupplement, {
          props: {
            costSupplement: row,
            opType: OpEnum.type.VIEW,
          },
          on: {
            audited: () => {
              this.$gjResetPage();
            }
          }
        });
      },
      // 编辑成本补录
      edit(row) {
        this.$gjCreate(AppOpCostSupplement, {
          props: {
            costSupplement: row,
            opType: OpEnum.type.UPDATE,
          },
          on: {
            audited: () => {
              this.$gjResetPage();
            }
          }
        });
      },
      auditPass(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '审核通过确认',
            content: rows.length === 1
              ? `确定要通过[${rows[0].code}]吗？`
              : `已选中 ${rows.length} 个补录单，确定要批量通过吗？`,
            contentStyle: {'color': '#333', 'font-size': '12px'},
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              auditPassCostSupplement(rows.map(e => e.id))
                .then(res => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      auditFail(rows) {
        const modal = this.$gjCreate('gj-textarea-modal', {
          props: {
            header: rows.length > 1 ? '审核驳回' : `审核驳回<span class="modal-secondary-title">${rows[0].code}</span>`,
            label: '驳回理由',
            labelWidth: '75px',
            contentStyle: {padding: '16px 20px'},
            notMargin: true
          },
          on: {
            submit: (rejectedReason) => {
              modal.confirmLoading = true;
              auditFailCostSupplement({
                ids: rows.map(e => e.id),
                rejectedReason,
              })
                .then(res => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      deleteItem(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '删除确认',
            content: rows.length === 1
              ? `确定要删除[${rows[0].code}]吗？`
              : `已选中 ${rows.length} 个补录单，确定要批量删除吗？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              deleteCostSupplement({
                ids: rows.map(e => e.id).join(','),
              })
                .then(res => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      openDetail(row, flag){
        if (flag) {
          row.itemPageVOList = row.productsCopy;
          row.expand = flag;
        } else {
          row.itemPageVOList = row.itemPageVOList.slice(0,3);
          row.expand = flag;
        }
        this.tableData = this.tableData.map(v => {
          if (v.id === row.id) {
            v.expand = row.expand
            v.itemPageVOList = row.itemPageVOList
          }
          return v
        })
        this.bakSelectedRows = this._.cloneDeep(this.selectedRows);
      }
    }
  };
</script>

<style scoped lang="scss">
.iconfont{
  font-size: 10px;
  color: #999;
}
.iconshouqi{
  margin-left: 5px;
}

/deep/ .has-append .el-input__inner:focus{
  border-right: 1px solid #1f6eef;
}
.default {
  /deep/ .gj-link{
    &:hover{
      .iconfont{
        color: #1F6EEF;
      }
    }
  }
}
</style>
